/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum DepreciationRuleId {
  US_Tax_BonusDepreciation = 100,
  US_Tax_Section179 = 101,
  US_Tax_PassengerAutomobiles = 102,
  US_Tax_TrucksAndVans = 103,
  US_Tax_ElectricVehicles = 104,
  US_Tax_HeavySportUtilities = 105,
  CA_Tax_AcceleratedInvestmentIncentive = 140,
  CA_Tax_ReacceleratedInvestmentIncentive = 141,
  CA_Tax_Class12HalfYearRule = 142,
  CA_Tax_Class53ImmediateExpensing = 143,
  CA_Tax_Class43Class53CarveOut = 144,
}
